require('./vue')
require('./modal')
require('./map')

if (document.querySelector('#app')) {
  window.__v_app = new window.Vue({
    el: '#app'
  })
}
